// @ts-check
import ProviderLocationInfoCard from './ProviderLocationInfoCard';

export default ProviderLocationInfoCard;
